module.exports = __webpack_public_path__ + "img/flank3.ecd971d8.png";